import React from 'react';
import { Trash2 } from 'lucide-react';
import { QuoteLineItem as QuoteLineItemType } from '../../types/calculator';
import { formatCurrency } from '../../utils/calculatorUtils';

interface QuoteLineItemProps {
  item: QuoteLineItemType;
  onQuantityChange: (id: string, quantity: number) => void;
  onRemove: (id: string) => void;
}

export const QuoteLineItem: React.FC<QuoteLineItemProps> = ({
  item,
  onQuantityChange,
  onRemove
}) => {
  return (
    <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-gray-900 truncate">{item.planName}</h4>
        <p className="text-sm text-gray-600">{item.priceLabel}</p>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <label htmlFor={`qty-${item.id}`} className="text-sm text-gray-600 whitespace-nowrap">
            Users:
          </label>
          <input
            id={`qty-${item.id}`}
            type="number"
            min="1"
            max="10000"
            value={item.quantity}
            onChange={(e) => onQuantityChange(item.id, parseInt(e.target.value) || 1)}
            className="w-20 px-2 py-1 border border-gray-300 rounded-md text-center focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div className="w-32 text-right">
          <p className="font-semibold text-gray-900">
            {item.quotable ? `${formatCurrency(item.subtotal)}/mo` : '—'}
          </p>
        </div>

        <button
          onClick={() => onRemove(item.id)}
          className="p-2 text-red-600 hover:bg-red-50 rounded-md transition-colors"
          title="Remove item"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
